/**
 * Key Numbers 1026 — BDU Stats
 * A solid bar of icon + count + label columns separated by vertical rules.
 * Colours reuse the shared gradient slots; labels below say what each one paints.
 */

export const KEY_NUMBERS_1026_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Stats",
  },

  DEFAULT_ROW: {
    id: "1",
    meta_icon: "",
    meta_icon_alt: "",
    meta_title: "33",
    meta_subtitle: "Years of Legacy",
    meta_priority: 1,
    meta_status: true,
  },

  KEY_NUMBERS_FIELDS_CONFIG: [
    {
      fieldName: "background_color",
      label: "Bar background",
      value: "#836537",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#836537",
    },
    {
      fieldName: "title_start_color",
      label: "Count text colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "description_color",
      label: "Label text colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "gradient_color_1",
      label: "Vertical rule between stats",
      value: "#22202369",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#22202369",
    },
    {
      fieldName: "gradient_color_2",
      label: "Icon circle fill",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "gradient_color_3",
      label: "Icon circle ring",
      value: "#e5e7eb",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#e5e7eb",
    },
    {
      fieldName: "status",
      label: "Section status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Icon",
      fieldName: "meta_icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload icon",
      defaultValue: "",
    },
    {
      header: "Icon alt",
      fieldName: "meta_icon_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Count",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "3600+",
      defaultValue: "",
    },
    {
      header: "Label",
      fieldName: "meta_subtitle",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Students",
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
